import { render, staticRenderFns } from "./WhatWeOffer.vue?vue&type=template&id=76b2674e&scoped=true&"
import script from "./WhatWeOffer.vue?vue&type=script&lang=js&"
export * from "./WhatWeOffer.vue?vue&type=script&lang=js&"
import style0 from "./WhatWeOffer.vue?vue&type=style&index=0&id=76b2674e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b2674e",
  null
  
)

export default component.exports